import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "comment" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "commentDate" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "commentAuthor" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_comment_text = _resolveComponent("comment-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comment.attachmentUrl, (item, i) => {
        return (_openBlock(), _createElementBlock("a", {
          class: "commentImage",
          key: i,
          href: item,
          target: "_blank"
        }, [
          _createElementVNode("img", { src: item }, null, 8, _hoisted_4)
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.comment.startDate)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$filters.date(_ctx.comment.createdOn, 'YYYY-MM-DD HH:mm')), 1))
        : (_openBlock(), _createElementBlock("b", _hoisted_7, " --> " + _toDisplayString(_ctx.$filters.date(_ctx.comment.startDate, 'YYYY-MM-DD HH:mm')), 1))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["commentBody", { pointer: _ctx.comment.subject }])
    }, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.comment.author.name), 1),
      _createVNode(_component_comment_text, { comment: _ctx.comment }, null, 8, ["comment"]),
      (_ctx.canRemove)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "commentRemover",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeComment && _ctx.removeComment(...args)), ["stop"]))
          }, _hoisted_10))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}